import { call, put, select, takeEvery } from "redux-saga/effects";
import {
    onInventoryChangeStockStatus,
    onInventoryChangeStockStatusFail,
    onInventoryChangeStockStatusSuccess,
    onInventoryLoad,
    onInventoryLoadFail,
    onInventoryLoadSuccess,
    onInventoryUpdateStockLimit,
    onInventoryUpdateType,
    onInventoryUpdateTypeFail,
    onInventoryUpdateTypeSuccess,
} from "./actions";
import * as api from "./api";

function* inventoryLoad(action) {
    try {
        const inventory = yield select((state) => state.inventory);

        const filter = {
            category: inventory.category,
            status: inventory.status,
        };
        const response = yield call(api.inventoryLoad, action.restId, filter);
        yield put(onInventoryLoadSuccess(response));
    } catch (e) {
        yield put(onInventoryLoadFail(e));
    }
}

function* inventoryChangeStatus(action) {
    try {
        const response = yield call(
            api.inventoryChangeStatus,
            action.restId,
            action.item,
            action.status
        );
        yield put(onInventoryChangeStockStatusSuccess());
    } catch (e) {
        yield put(onInventoryChangeStockStatusFail(e));
    }
}
function* inventoryUpdateType(action) {
    try {
        const response = yield call(
            api.inventoryUpdateType,
            action.restId,
            action.item,
            action.orderType
        );
        yield put(onInventoryUpdateTypeSuccess());
    } catch (e) {
        yield put(onInventoryUpdateTypeFail(e));
    }
}

function* inventoryUpdateStockLimit(action) {
    try {
        const response = yield call(
            api.inventoryUpdateStockLimit,
            action.restId,
            action.item,
            action.limit
        );
        yield put(onInventoryUpdateTypeSuccess());
    } catch (e) {
        yield put(onInventoryUpdateTypeFail(e));
    }
}

function* categoriesSaga() {
    yield takeEvery(onInventoryLoad().type, inventoryLoad);
    yield takeEvery(onInventoryChangeStockStatus().type, inventoryChangeStatus);
    yield takeEvery(onInventoryUpdateType().type, inventoryUpdateType);
    yield takeEvery(
        onInventoryUpdateStockLimit().type,
        inventoryUpdateStockLimit
    );
}

export default categoriesSaga;
